<div class="flex items-center w-full">
    @if (supportNewContainer) {
        <app-input-cell-container
            [field]="field()"
            [formControl]="fieldValueFormControl()"
            [appearance]="inputAppearance()"
            [hoverIcons]="hoverIcons()"
        >
        </app-input-cell-container>
    } @else if (isFieldNonText) {
        <app-cell-container
            [fieldTypes]="fieldTypes()"
            [field]="field()"
            [value]="fieldValueFormControl().value ?? ''"
            (cellValueChanged)="cellValueChanged($event)"
            [hoverIcons]="hoverIcons()"
            [record]="record()"
        ></app-cell-container>
    } @else {
        <app-tb-input
            [formControl]="fieldValueFormControl()"
            (keydown.enter)="updateOnEnter()"
            class="w-full"
        ></app-tb-input>
    }
</div>
